import { render, staticRenderFns } from "./EditProgramGenz.vue?vue&type=template&id=c68e4476&scoped=true"
import script from "./EditProgramGenz.vue?vue&type=script&lang=js"
export * from "./EditProgramGenz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68e4476",
  null
  
)

export default component.exports